// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="-1801 -3099 10 10"><path className="a" d="M-1801-3099v10h10v-10zm9.2 9.2h-8.3v-8.3h8.3z"/></svg>
);

export default fn;
